import { render, staticRenderFns } from "./MemberDiscountListTable.vue?vue&type=template&id=c853f6d0&"
import script from "./MemberDiscountListTable.vue?vue&type=script&lang=js&"
export * from "./MemberDiscountListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports